// @flow

export function goToRoute(route: string): void {
  // TODO: is this the best way to change route?
  window.location.replace(
    window.location.pathname + window.location.search + '#/' + route
  );
}



// WEBPACK FOOTER //
// ./src/util/routeUtils.js